"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEPOSIT_ALTERNATIVE_3RD_PARTY_FIELD = exports.DEPOSIT_ALTERNATIVE_FIELD = void 0;
var DEPOSIT_ALTERNATIVE_FIELD_1 = require("./DEPOSIT_ALTERNATIVE_FIELD");
Object.defineProperty(exports, "DEPOSIT_ALTERNATIVE_FIELD", { enumerable: true, get: function () { return DEPOSIT_ALTERNATIVE_FIELD_1.DEPOSIT_ALTERNATIVE_FIELD; } });
var DEPOSIT_ALTERNATIVE_3RD_PARTY_FIELD_1 = require("./DEPOSIT_ALTERNATIVE_3RD_PARTY_FIELD");
Object.defineProperty(exports, "DEPOSIT_ALTERNATIVE_3RD_PARTY_FIELD", { enumerable: true, get: function () { return DEPOSIT_ALTERNATIVE_3RD_PARTY_FIELD_1.DEPOSIT_ALTERNATIVE_3RD_PARTY_FIELD; } });
